import SVG from "react-inlinesvg";
import classnames from "classnames";
import React from "react";

import FileIcon from "@krea/common/images/svg/link-attached.svg";

const InputLinkPreview = ({ value, className }) => {
  return (
    <div className={classnames("d-flex align-items-center", className)}>
      <div
        className={classnames("position-relative shrink-0")}
        style={{ width: "1.125rem", height: "1.125rem" }}
      >
        <SVG
          className="position-absolute w-100 h-auto"
          src={FileIcon}
          style={{ top: "0", left: "0" }}
        />
      </div>
      <div className="w-100 pl-2 text-truncate">{value}</div>
    </div>
  );
};

export default InputLinkPreview;
